import React from "react";
import "./style/PimageChange.scss";

const PimageChage = () => {
  return <div className="PimageChange_container"></div>;
};

export default PimageChage;
